/* ================================================== */
/* CONTROLLER → Address
/* ================================================== */

var previousAddress = null;

app.controller('addressCtrl', ['$rootScope', '$scope', '$http', '$compile', function($rootScope, $scope, $http, $compile) {

	// Init
	var currentStepFieldsetAddressClass = '.step:not(.ng-hide) .fieldset--address',
		autocompleteClass               = 'autocomplete',
		resultsClass                    = 'open-autocomplete',
		$fieldsetAddress                = $(currentStepFieldsetAddressClass);


	/* ================================================== */
	/* CONTROLLER → Address → autocomplete
	/* ================================================== */

	// Append autocomplete
	$scope.appendAutocomplete = function(address) {
		// Append autocomplete
		if ($('.step:not(.ng-hide) .' + autocompleteClass).length === 0) {
			$fieldsetAddress.append('<ul class="' + autocompleteClass + '"></ul>');
		}

		// Append suggestion
		var addressParam = "'" + address + "'";
		var result       = $compile('<li class="' + autocompleteClass + '__item"> \
										<a \
											tabindex="0" \
											role="button" \
											class="link link--js" \
											data-ng-click="getAddress(' + addressParam + ')" \
											data-ng-keydown="getAddressOnEnter($event, ' + addressParam + ')">'
												+ address +
										'</a> \
									</li>')($scope);
		angular.element($('.autocomplete', currentStepFieldsetAddressClass)).append(result);
	}

	// Get address when 'Enter' key pressed
	$scope.getAddressOnEnter = function(keyEvent, address) {
		if (keyEvent.which === 13) {
			$scope.getAddress(address);
		}
	}

	// Reset autocomplete
	$rootScope.resetAutocomplete = function() {
		$('.' + autocompleteClass, $fieldsetAddress).remove();
		$('input', $fieldsetAddress).removeClass(resultsClass);
	}


	/* ================================================== */
	/* CONTROLLER → Address → suggestions
	/* ================================================== */

	// Get suggestions
	$scope.getSuggestions = function(model) {
		// If address has more than 3 characters
		if (typeof model !== 'undefined' && model.length > 2) {

			var limit = 5;

			$http({
				method: 'GET',
				url: 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + encodeURIComponent(model) + '.json',
				params: {
					country      : 'BE',
					proximity    : '4.35,50.83', // Keep like this → no array
					types        : 'address',
					bbox         : '4.243766184559114,50.76367856897059,4.482294099900855,50.91384361014993',
					limit        : limit,
					language     : 'FR,NL',
					access_token : 'pk.eyJ1IjoiZXZlcnl0aGluZ2lzZnVuIiwiYSI6IkVkalZJRUkifQ.i_Taxju9f5wO9aUyOF7Gyg'
				}
			})
			.then(function(response) {

				// Remove input search bottom radius
				$('input', $fieldsetAddress).addClass(resultsClass);

				// Prepare autocomplete (add / clear)
				if ($('.' + autocompleteClass, $fieldsetAddress).length === 0) {
					$fieldsetAddress.append('<ul class="' + autocompleteClass + '"></ul>');
				} else {
					$('.' + autocompleteClass, $fieldsetAddress).html('');
				}
				
				if (response.data.features.length > 0) {

					// Append suggestions to autocomplete
					angular.forEach(response.data.features, function(value, key) {

						if (key < limit && ($rootScope.lang == 'fr' && typeof value.place_name_FR !== 'undefined') || ($rootScope.lang == 'nl' && typeof value.place_name_NL !== 'undefined')) {
							// Prepare address
							var lang                  = ($rootScope.lang == 'nl') ? 'text_NL' : 'text_FR',
								street                = (typeof value[lang] !== 'undefined') ? value[lang].split(' - ')[($rootScope.lang == 'nl') ? 1 : 0] ?? value[lang] : null,
								number                = (typeof value.address !== 'undefined' && value.address !== null) ? ((street !== null) ? ' ' : null) + value.address : '',

								postcodeSeparator     = (street !== null || number !== null) ? ', ' : null,
								postcode              = (typeof value.context[0][lang] !== 'undefined') ? postcodeSeparator + value.context[(parseInt(value.context[0][lang], 10)) ? 0 : 1][lang] : null,

								municipalitySeparator = ((street !== null || number !== null) && postcode === null) ? ', ' : (postcode !== null) ? ' ' : null,
								municipality          = (typeof value.context[2][lang] !== 'undefined') ? municipalitySeparator + value.context[(parseInt(value.context[0][lang], 10) > 0) ? 2 : 1][lang] : null,

								address               = (street + number + postcode + municipality).replace(/'/g, 'ʼ');

								if (number) {
								}
								// Append address
								$scope.appendAutocomplete(address);

						}
					});

					// Remove suggestions on click outside
					$('*:not(.fieldset--address)').click(function(){
						if ($('.autocomplete__item').length > 0) {
							$rootScope.resetAutocomplete();
						}
					});

				} else {
					$('input', $fieldsetAddress).removeClass(resultsClass);
				}

			});

		} else if ($('.' + autocompleteClass, $fieldsetAddress).length) {
			$rootScope.resetAutocomplete();
		}
	}

	// Append suggestion
	$scope.appendSuggestion = function(address, pointX, pointY, noResult) {
		// Append autocomplete
		if ($('.step:not(.ng-hide) .' + autocompleteClass).length === 0) {
			$fieldsetAddress.append('<ul class="' + autocompleteClass + '"></ul>');

			var errorMessage = {
				fr: [
					'Cette adresse est incomplète, nʼexiste pas ou se trouve en dehors de la zone concernée.',
					'Veuillez entrer une nouvelle adresse complète, ou essayer lʼune des suggestions suivantes.'
				],
				nl: [
					'Dit adres onvolledig is, bestaat niet of is buiten het gebied.',
					'Vul een compleet nieuw adres, of probeer een van de volgende suggesties.'
				]
			}
			errorMessage = errorMessage[$rootScope.lang];

			if (typeof noResult !== 'undefined' && noResult === true) {
				$fieldsetAddress.find('.' + autocompleteClass).append('<li class="' + autocompleteClass + '__item ' + autocompleteClass + '__item--no-result"><a class="link link--disabled"><span>' + errorMessage[0] + '</span><span>' + errorMessage[1] + '</span></a></li>');
			}
		}

		// Append suggestion
		var addressParam = "'" + address + "'";
			result       = $compile('<li class="' + autocompleteClass + '__item"><a tabindex="0" role="button" class="link link--js" data-ng-click="submitSuggestion(' + addressParam + ',' + pointX + ',' + pointY + ')">' + address + '</a></li>')($scope);
		// angular.element($fieldsetAddress.find('.' + autocompleteClass)).append(result);
		angular.element($(currentStepFieldsetAddressClass + ' .' + autocompleteClass)).append(result);
	}

	// Submit suggestion
	$scope.submitSuggestion = function(address, pointX, pointY) {
		// Disable mouseover
		$rootScope.isMarkerInsidePolygon(pointX, pointY);

		// Open popup if outside of areas
		if ($rootScope.hasGq($rootScope.formDataRaw.neighborhoodId) === false) {
			popupNeighborhood($rootScope.formDataRaw.neighborhood, lang);

		// Go to result
		} else {
			$rootScope.goToStep(resultsStepIndex, true);
		}
	}


	/* ================================================== */
	/* CONTROLLER → Address → get
	/* ================================================== */

	// Get address
	$scope.getAddress = function(address) {

		// Remove apostrophe
		address = (address).replace(/ʼ/g, "'");

		// Check if address is different than previous one
		if (previousAddress === null || previousAddress !== address) {

			// Apply suggestion
			$rootScope.formDataRaw.location = address;

			// Re-init
			previousAddress = address;

			// Get data
			$http({
				method: 'GET',
				url: 'https://geoservices.irisnet.be/localization/Rest/Localize/getaddresses',
				params: {
					language        : $rootScope.lang,
					address         : address,
					spatialReference: 4326
				}
			}).then(function successCallback(response) {

				// Init
				var response = response.data.result;

				// Single result
				if (typeof response !== 'undefined') {
					if (response.length === 1) {

						// Highlight area
						var result = response[0],
							pointX = result.point.x,
							pointY = result.point.y;
						$rootScope.isMarkerInsidePolygon(pointX, pointY);

						// Clear suggestions
						$rootScope.resetAutocomplete();

						if ($rootScope.hasGq($rootScope.formDataRaw.neighborhoodId) === false) {
							popupNeighborhood($rootScope.formDataRaw.neighborhood, lang);
						} else {
							// Go to result
							$rootScope.goToStep(resultsStepIndex, true);
						}

						// Release focus
						$('input[type="search"]').blur();

					// Several results
					} else if (response.length > 1) {

						// Suggestions
						angular.forEach(response, function(value, key) {
							if (key < 8) {
								// Prepare address
								var pointX       = value.point.x,
									pointY       = value.point.y,

									address      = value.address,

									street       = address.street.name,
									number       = ((street !== null && address.number != '') ? ' ' : '') + address.number,
									postcode     = (((street !== null || number !== null) && address.street.postCode != '') ? ', ' : '') + address.street.postCode,
									municipality = (((street !== null || number !== null) && postcode === null) ? ', ' : (postcode !== null) ? ' ' : '') + address.street.municipality,

									address      = (street + number + postcode + municipality).replace(/'/g, 'ʼ');

								// Clear previous suggestions
								if (key === 0 && $(autocompleteClass, $fieldsetAddress).html() !== null) {
									$rootScope.resetAutocomplete();
								}

								// Remove input search bottom radius
								if (!$('input', $fieldsetAddress).hasClass(resultsClass)) {
									$('input', $fieldsetAddress).addClass(resultsClass);
								}

								// Append suggestion
								$scope.appendSuggestion(address, pointX, pointY, true);
							}
						});

					}
				}
			});

		}

	}

}]);